module.exports = __webpack_public_path__ + "static/media/backgroundimg.d0bc1989.jpg";